import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import question from "content/images/help.png"
import ReactTooltip from 'react-tooltip';

const settingsImg = "https://hrflow-ai.imgix.net/settings.svg"
const handsLogo = 'https://hrflow-ai.imgix.net/hands-pen.svg'
const ideaImg = "https://hrflow-ai.imgix.net/idea.svg"
const handShake = "https://hrflow-ai.imgix.net/hands-shake.svg"
const lineImg = "https://hrflow-ai.imgix.net/line.svg"
const checkIcon = "https://hrflow-ai.imgix.net/check.svg"
const spotLeft = 'https://hrflow-ai.imgix.net/backgrounds/yellow-spot-left.svg'
const spotMid = 'https://hrflow-ai.imgix.net/backgrounds/yellow-spot-mid.svg'
const spotRight = 'https://hrflow-ai.imgix.net/backgrounds/yellow-spot-right.svg'


const StyledWrapper = styled.div`
  display: flex;
  z-index: 1;
  flex-direction: column;
  justify-content: center;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-right: 2.5rem;
    padding-left: 2.5rem;
    flex-direction: row;
  }

`

const StyledCard = styled.div`
  position: relative;
  max-width: 400px;
  margin: 0;
  margin-bottom: 2rem;
  max-width: 100%;
  background: #fff;
  border: .1rem solid ${props => props.color};
  border-radius: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  .label-wrapper {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    transform: translateY(-50%);
  }
  .label {
    background: rgb(24,61,99);
    color: white;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    padding: 8px 12px;
    font-weight: 900;
    font-size: 10px;
    line-height: 10px;
    letter-spacing: .5px;
    text-transform: uppercase;
    border-radius: 40px;
  
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin: 0 1rem;
    width: 20rem;
  }
  .header {
    text-align: center;
    padding-top: 3rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // border-bottom: .1rem solid #d8ecf3;
    background-size: 2.8rem 3.35rem, 16rem 22.6rem, 3.15rem 3.9rem;
    background-repeat: no-repeat;
    background-position: 10% 10%, 34% -41%, 92% 50%;
    img {
      width: auto;
      height: 5rem;
      margin-bottom: 1rem;
    }
    h3 {
      margin-bottom: 0;
      color: ${props => props.color};
    }
    p {
      color: #00495D;
      text-align: center;
      font-weight: 700;
      font-family: Plain-regular;
      font-size: 1.2rem;
    }
    .type {
      font-size: 1.7rem;
      line-height: 2.3rem;  
      color: ${({ theme }) => theme.colors.secondary};
    }
    .light {
      font-size: 14px;
      font-style: italic;
      font-family: 'plain-thin';
      color: #00495d;
    }
    .line {
      background-image: url(${lineImg});
      background-repeat: no-repeat;
      background-size: 17rem .1rem;
      height: .1rem;
      width: 17rem;
      margin: 1rem;
    }
    .img-help {
      height: 1rem;
      margin-bottom: 0;
      margin-left: 0.5rem;
    }
    .feature {
      font-weight: 700;
      font-family: 'plain-regular';
    }
  }
  .body {
    padding-top: 2rem;
    padding-bottom: 1.3rem;
    padding-left: 1rem;
    padding-right: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .feature {
      margin: 1rem 0;
      text-align: center;
      display: flex;
      img {
        margin-right: 0.5rem;
      }

      span {
        font-weight: 700;
        color: ${({ theme }) => theme.colors.secondary};
      }
    }
    .line {
      background-image: url(${lineImg});
      background-repeat: no-repeat;
      background-size: 22.45rem .1rem;
      height: .1rem;
      width: 22.45rem;
    }
    .more {
      font-size: 0.9rem;
      font-weight: 600;
      text-transform: uppercase;
      color: ${({ theme }) => theme.colors.secondary};
      border-bottom: .1rem solid ${({ theme }) => theme.colors.secondary};
      margin-top: 2.16rem;
      padding-bottom: 0.3rem;
      cursor: pointer;
      width: fit-content;
    }
  }
  .bottom {
    padding: 2rem;
  }
  &.starter {
    .header {
      .type {
        color: #80D930;
      }
      .light {
        color: #80D930;
      }
      a {
        background: #80D930;
        color: white;
        border: #80D930;
      }
      background-image: url(${spotLeft}), url(${spotMid}), url(${spotRight});
    }
  }
`

const StyledLargeButton = styled(Link)`
  padding: 1rem 0;
  margin: 1rem 0;
  width: 100%;
  border-color: #fff;
  border: .1rem solid ${props => props.color};
  background-color: ${props => props.color};
  color: white;
  font-size: 0.8rem;
  font-weight: 700;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: .065rem;
  border-radius: 0.2rem;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
`

const Plan = ({ plans }) => {
  return (
    <StyledWrapper>
      {plans.map(({name, title, subtitle, icon, descriptionLine1, descriptionLine2, type, buttonText, buttonLink, items, color }, key) => {
        return (
          <StyledCard key={`${key}-card`} color={color} className={`${name}`}>
            {name === "essentials" && (<div className="label-wrapper"><span className="label">Most Popular</span></div>)}
            <div className="header">
              <img src={`https://hrflow-ai.imgix.net/${icon}.svg`} alt="settings icon" />
              <h3>{title}</h3>
              <p className="text">
                {descriptionLine1} <br /> {descriptionLine2}
              </p>
              <div className="light">{subtitle}</div>
              <div className="line"></div>
              <div>
              {items.map((f, k) => {
                return (
                  <>
                    <div key={`${k}-feature`} className="feature">
                      <div>
                        {f.title}
                        {f.tooltip && (
                          <span className="tool" data-tip={f.tooltip}>
                            <img class="img-help"  src={question}  alt="tooltip img"/>
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="line"></div>
                  </>
                )
              })}
              </div>
            </div>
            <StyledLargeButton color={color} target="blank" to={buttonLink}>
              {buttonText}
            </StyledLargeButton>
           {/*  <div className="body">
             
              {features.map((f, k) => {
                return (
                  <>
                    <div key={`${key}-feature`} className="feature">
                      <img src={checkIcon}  alt="check icon" />
                      <div>{f}</div>
                    </div>
                    <div className="line"></div>
                  </>
                )
              })}
              <a href="#coreFeatures" className="more" >AND MORE  </a>
            </div> */}
          </StyledCard>
        )
      })}
    </StyledWrapper>
  )
}


export default Plan